module.exports = __webpack_public_path__ + "img/ok.1e472789.png";